import { render, staticRenderFns } from "./RemuneracaoProcedimentosDescartadosRightNavBar.vue?vue&type=template&id=3d866787"
import script from "./RemuneracaoProcedimentosDescartadosRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoProcedimentosDescartadosRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoProcedimentosDescartadosRightNavBar.vue?vue&type=style&index=0&id=3d866787&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports